export function addMonths(year, month, delta) {
  const date = new Date(year, month + delta, 1);
  return {
    year: date.getFullYear(),
    month: date.getMonth()
  };
}
export function getVisibleMonthViews(year, month, count) {
  const safeCount = Math.max(1, Math.min(count, 12));
  return Array.from({
    length: safeCount
  }, (_, offset) => {
    const next = addMonths(year, month, offset);
    return {
      year: next.year,
      month: next.month,
      offset
    };
  });
}